import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';

function GmpTrainingPrograms() {
  return (
    <div className="font-sans">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'Trainings', 'GMP Training Programs']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Trainings
        </h2>

        <div className="flex items-center gap-2 mb-4 mt-12">
          <span className="w-4 h-4 rounded-full bg-sky-300  flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            GMP Training Programs
          </h3>
        </div>

        <p className="mb-4 text-[#05326D] font-bold">
          Empowering Teams with Practical Compliance Knowledge Across Pharma, Biotech & Food Industries
        </p>

        <p className="mb-6 text-[#05326D]">
          At FDAC Consultancy, we offer a comprehensive suite of GMP, GLP, and GDP training programs designed to strengthen regulatory compliance,
          operational excellence, and workforce readiness. Delivered onsite, online, or in regional training hubs, our sessions are tailored to meet the
          evolving needs of pharmaceutical, biotech, and food industry professionals.
        </p>

        <p className="mb-8 text-[#05326D]">
          Whether you’re preparing for audits, enhancing documentation practices, or onboarding new staff, FDAC’s training modules provide actionable
          insights grounded in real-world scenarios.
        </p>

        <hr className="border-t border-gray-300 mb-8" />

        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Training Focus Areas
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">GMP & cGMP Fundamentals</p>
        <p className="ml-2 mt-2 text-[#05326D]">FDA GMP Compliance & Audit Preparedness</p>
        <p className="ml-2 mt-2 text-[#05326D]">Validation & Documentation Best Practices</p>
        <p className="ml-2 mt-2 text-[#05326D]">Data Integrity & Risk Mitigation</p>
        <p className="ml-2 mt-2 text-[#05326D]">Good Documentation Practices (GDP)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Advanced cGMP Modules for Regulated Markets</p>


        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Practical & Role-Based Training
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Shop Floor & Operator Training: Practical demonstrations, equipment handling & hygiene protocols, certificate-based programs for freshers</p>
        <p className="ml-2 mt-2 text-[#05326D]">Officer & Executive Training: Classroom sessions for QA, QC, Production, Warehouse & Marketing teams, evaluation-based learning with performance tracking</p>
        <p className="ml-2 mt-2 text-[#05326D]">Managerial & Supervisory Training: Strategic modules on audit readiness, change management, and regulatory leadership</p>

        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Training Formats
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Onsite Workshops at client facilities</p>
        <p className="ml-2 mt-2 text-[#05326D]">Virtual Training Sessions for remote teams</p>
        <p className="ml-2 mt-2 text-[#05326D]">City-Based Seminars for regional outreach</p>
        <p className="ml-2 mt-2 text-[#05326D]">Custom Modules for ongoing internal training needs</p>

        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Why FDAC?
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Real-world case studies integrated into every session</p>
        <p className="ml-2 mt-2 text-[#05326D]">Unified understanding across teams for effective change management</p>
        <p className="ml-2 mt-2 text-[#05326D]">Training aligned with GxP, FDA, EU GMP, and global standards</p>
        <p className="ml-2 mt-2 text-[#05326D]">Proven success in preparing teams for regulatory inspections and operational excellence</p>


        <p className="text-[#05326D] mt-4">
          Our GMP training goes beyond compliance — it builds confidence, sharpens operational discipline, and fosters a culture of quality.
        </p>
      </div>
    </div>
  );
}

export default GmpTrainingPrograms;
